import { StepObject } from '../../types';

type ShowFinishedProps = {
  steps: StepObject[];
  currentStepIndex: number;
};
export const showFinished = ({ steps, currentStepIndex }: ShowFinishedProps) =>
  currentStepIndex + 1 > steps.length;
